module.exports = __webpack_public_path__ + "img/plenary_session.f41e2d3c.png";